export default __webpack_public_path__ + "static/media/immune.9817fd75.jpg";